function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBw1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.467507,0,0,0.467507,-68.0571,-110.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.091,450.339C272.898,464.088 254.734,473.771 236.523,476.23C236.238,489.109 240.167,503.368 247.883,515.144C255.6,526.92 267.105,536.215 279.026,541.095C290.847,546.216 305.534,547.955 319.351,545.25C333.168,542.544 346.115,535.395 355.131,526.194C364.332,517.178 371.482,504.231 374.187,490.414C376.893,476.597 375.154,461.909 370.033,450.089C365.152,438.167 355.858,426.662 344.082,418.946C332.305,411.229 318.047,407.3 305.168,407.585C304.045,415.398 301.74,423.124 298.398,430.274C305.484,427.585 315.441,430.722 319.706,436.987C324.585,442.787 324.913,453.221 320.409,459.317C316.546,465.838 306.807,469.595 299.565,467.357C292.134,465.865 285.371,457.913 285.091,450.339Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.467507,0,0,0.467507,-68.0571,-110.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.661,375.091C237.912,362.898 228.229,344.734 225.77,326.523C212.891,326.238 198.632,330.167 186.856,337.883C175.08,345.6 165.785,357.105 160.905,369.026C155.784,380.847 154.045,395.534 156.75,409.351C159.456,423.168 166.606,436.115 175.806,445.131C184.822,454.332 197.769,461.482 211.586,464.187C225.404,466.893 240.091,465.154 251.911,460.033C263.833,455.152 275.338,445.858 283.054,434.082C290.771,422.305 294.7,408.047 294.415,395.168C286.602,394.045 278.876,391.74 271.726,388.398C274.415,395.484 271.278,405.441 265.013,409.706C259.213,414.585 248.779,414.913 242.683,410.409C236.162,406.546 232.406,396.807 234.643,389.565C236.135,382.134 244.087,375.371 251.661,375.091Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.467507,0,0,0.467507,-68.0571,-110.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.909,341.661C339.102,327.912 357.266,318.229 375.477,315.77C375.762,302.891 371.833,288.632 364.117,276.856C356.4,265.08 344.895,255.785 332.974,250.905C321.153,245.784 306.466,244.045 292.649,246.75C278.832,249.456 265.885,256.605 256.869,265.806C247.668,274.822 240.518,287.769 237.813,301.586C235.107,315.404 236.846,330.091 241.967,341.911C246.848,353.833 256.142,365.338 267.918,373.054C279.695,380.771 293.953,384.7 306.832,384.415C307.955,376.602 310.26,368.876 313.602,361.726C306.516,364.415 296.559,361.278 292.294,355.013C287.415,349.213 287.087,338.779 291.591,332.683C295.454,326.162 305.193,322.406 312.435,324.643C319.866,326.135 326.629,334.087 326.909,341.661Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Red",
    transform: "matrix(0.467507,0,0,0.467507,-68.0571,-110.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.339,416.909C374.088,429.102 383.771,447.266 386.23,465.477C399.109,465.762 413.368,461.833 425.144,454.117C436.921,446.4 446.215,434.895 451.095,422.974C456.216,411.153 457.955,396.466 455.25,382.649C452.544,368.832 445.395,355.885 436.194,346.869C427.178,337.668 414.231,330.518 400.414,327.813C386.597,325.107 371.909,326.846 360.089,331.967C348.167,336.848 336.662,346.142 328.946,357.918C321.229,369.695 317.3,383.953 317.585,396.832C325.398,397.955 333.124,400.26 340.274,403.602C337.585,396.516 340.722,386.559 346.987,382.294C352.787,377.415 363.221,377.087 369.317,381.591C375.838,385.454 379.595,395.193 377.357,402.435C375.865,409.866 367.913,416.629 360.339,416.909Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBw1);
export default __webpack_public_path__ + "static/media/logo_bw_1.7dfd684f189216d017ce063febbb2ebf.svg";
export { ForwardRef as ReactComponent };